<template>
  <ion-page>
    <master-layout pageTitle="لیست سفارشات فروشگاه">
      <ion-card>
        <ion-card-content>
          <DataTable :headers="headers" :route="route"></DataTable>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  IonCard, IonCardContent, IonPage
} from "@ionic/vue";

export default {
  data()
  {
    return {
      id: null,
      route:'shopOrder/listAjax',
      headers: [
        'شماره سفارش',
        'تاریخ ایجاد',
        'مبلغ سفارش',
          'وضعیت',
          'مشاهده'
      ]
    };
  },
  async created()
  {
    this.id = this.$route.params.id;
  },
  components: {
    IonCard, IonCardContent, DataTable, IonPage
  }
};
</script>

<style scoped>

</style>